// extracted by mini-css-extract-plugin
export default {"listKeyValue":"src-components-ListKeyValue-style__Q6yfz__listKeyValue"};